var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"txt_info txt_gray",class:_vm.errorContextProps.isError ? 'hidden' : ''},[_vm._v("\n    "+_vm._s(_vm.$t('account.request_email+id_sentence'))+"\n  ")]),_c('p',{staticClass:"txt_info txt_red",class:_vm.errorContextProps.isError ? '' : 'hidden'},[_vm._v("\n    "+_vm._s(_vm.errorContextProps.context)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }